import React, { useState, useEffect } from 'react';

import { Modal, Backdrop, Fade, makeStyles } from '@material-ui/core';
import Text from '../Typography/Text';
import TextField from '../Textfields/TextField';
import Button from '../Buttons/Button';
import fontFamily from '../../assets/css/fonts';
import color from '../../assets/css/colors';
import CloseButton from '../Buttons/CloseButton';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 800,
    width: '100%',
    margin: '0 auto',
    float: 'clear',
  },
  modalHeader: {
    backgroundColor: 'white',
    padding: 25,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    borderBottom: '1px solid #ccc',
    display: 'flex',
    '& div:nth-child(1)': {
      flex: 1,
    },
    '& div:nth-child(2)': {
      flex: 'none',
      '& .MuiIconButton-root': {
        borderRadius: 5,
        padding: 10,
        '&:hover svg path': {
          fill: color.primary.main,
        },
      },
      '& svg:last-child': {
        width: 15,
        height: 15,
      },
    },
  },
  modalBody: {
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    fontFamily: fontFamily.headers,
    '& p': {
      fontSize: 16,
      lineHeight: '24px',
    },
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    position: 'relative',
    '& button': {
      width: 'auto',
    },
  },
  closeButton: {
    '& button': {
      marginTop: '-4px !important',
    },
  },
}));

export default function HelpModal({ onClose, open: isOpen, id, loading }) {
  const classes = useStyles();
  const [modalData, setModalData] = useState({});

  console.log(isOpen, id);

  useEffect(() => {
    if (isOpen && id) {
      const init = async () => {};

      init();
    }
  }, [isOpen, id]);

  const handleChange = (e) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;
    setModalData({
      ...modalData,
      [input.name]: input.value,
    });
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={isOpen}
      onClose={() => onClose()}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={isOpen}>
        <div style={{ width: 800 }}>
          <div className={classes.modalHeader}>
            <div>
              <Text mt={4} variant="h3" label={'Get Help'} />
              <div className="grid-row">
                <Text
                  mt={1}
                  label={
                    'In order to assist you better, please answer the following questions'
                  }
                />
              </div>
            </div>
            <div className={classes.closeButton}>
              <CloseButton onClick={() => onClose()} />
            </div>
          </div>
          <div className={classes.modalBody}>
            <div className="grd-row nm">
              <div className="grd-cell" style={{ textAlign: 'center' }}>
                <TextField
                  fullWidth
                  required
                  name="topic"
                  label="Topic"
                  value={modalData.topic}
                  onChange={handleChange}
                  inputProps={{ maxLength: 100 }}
                  InputLabelProps={{ shrink: true }}
                  mt={4}
                />
              </div>
            </div>
            <div className="grd-row nm">
              <div className="grd-cell" style={{ textAlign: 'center' }}>
                <TextField
                  fullWidth
                  required
                  name="description"
                  label="Decription"
                  value={modalData.description}
                  onChange={handleChange}
                  inputProps={{ maxLength: 100 }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
            </div>
            <div className="grd-row nm">
              <div className="grd-cell" style={{ textAlign: 'center' }}>
                <TextField
                  fullWidth
                  required
                  name="additionalInformation"
                  label="Additonal Information"
                  value={modalData.additionalInformation}
                  onChange={handleChange}
                  inputProps={{ maxLength: 100 }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
            </div>
          </div>
          <div className={classes.modalFooter}>
            <div className={classes.grdCellNone} style={{ marginRight: 10 }}>
              <Button
                disabled={loading}
                loading={loading}
                color="secondary"
                label={loading ? 'Submitting...' : 'Submit'}
                onClick={() => {
                  onClose(modalData, 'verify');
                }}
              />
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
